import { NormalizedGroup } from '../../../redux/groups/api/GroupAdapter';

const normalizeCompanyName = (name: string): string => {
  return name.trim().toUpperCase().replace(/\s+/g, '');
};

const isCompanyNameMatch = (name1: string, name2: string): boolean => {
  if (!name1 || !name2) return false;
  return normalizeCompanyName(name1) === normalizeCompanyName(name2);
};

export const findMatchingCompany = (
  invitationCompanyName: string,
  availableCompanies: Record<string, NormalizedGroup> | undefined
): NormalizedGroup | undefined => {
  return Object.values(availableCompanies || {}).find((company) =>
    isCompanyNameMatch(company?.name, invitationCompanyName)
  );
};
